var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClientsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "increase",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.482,
    height: 41.5,
    viewBox: "0 0 54.482 41.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M36.385,113.769a6.385,6.385,0,1,1,6.385-6.385A6.392,6.392,0,0,1,36.385,113.769Z",
    transform: "translate(-26.808 -96.744)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M246.385,73.769a6.385,6.385,0,1,1,6.385-6.385A6.392,6.392,0,0,1,246.385,73.769Z",
    transform: "translate(-214.461 -61)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M52.886,161H46.5a1.6,1.6,0,1,0,0,3.192h2.531L32.668,180.557l-4.192-4.192a1.6,1.6,0,0,0-2.257,0l-12.3,12.3H1.6a1.6,1.6,0,0,0,0,3.192H14.578a1.6,1.6,0,0,0,1.129-.468l11.641-11.641,4.192,4.192a1.6,1.6,0,0,0,2.257,0L51.29,166.45v2.531a1.6,1.6,0,0,0,3.192,0V162.6A1.6,1.6,0,0,0,52.886,161Z",
    transform: "translate(0 -150.359)",
    fill: "#e1591f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    d: "M224.868,195.978a9.556,9.556,0,0,1-10.582,0A9.568,9.568,0,0,0,210,203.961v3.018l1.615-1.615a4.789,4.789,0,0,1,6.772,0l1.935,1.935,7.754-7.754A9.623,9.623,0,0,0,224.868,195.978Z",
    transform: "translate(-187.654 -181.615)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    d: "M4.286,235.978A9.568,9.568,0,0,0,0,243.961v8.513H12.595l6.559-6.559v-1.954a9.568,9.568,0,0,0-4.286-7.983,9.556,9.556,0,0,1-10.582,0Z",
    transform: "translate(0 -217.358)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClientsWhite);
export default __webpack_public_path__ + "static/media/icon-clients-white.b312ea5e7c2d24034a46ee96cff4a995.svg";
export { ForwardRef as ReactComponent };